export default __webpack_public_path__ + "static/media/Upload_1.afd10644.png";